import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/brave_bites_new_logo.png'


const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "button-row" }
const _hoisted_3 = {
  type: "submit",
  class: "button primary"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "loader button-loader"
}
const _hoisted_6 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "nav-logo-container" }, [
      _createElementVNode("img", {
        class: "login-logo",
        src: _imports_0,
        alt: "Brave Bites Logo"
      }),
      _createElementVNode("h1", { class: "title" }, "Brave Bites"),
      _createElementVNode("p", { class: "subtitle" }, "Helping you face food, one bite at a time.")
    ], -1)),
    _createElementVNode("form", {
      class: "login_form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.authenticate && $setup.authenticate(...args)), ["prevent"]))
    }, [
      _cache[3] || (_cache[3] = _createElementVNode("label", { class: "medium" }, "Email", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
        placeholder: "example@example.com",
        required: ""
      }, null, 512), [
        [_vModelText, $setup.email]
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "medium" }, "Password", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
        placeholder: "y0ur pAs3W0rd",
        required: ""
      }, null, 512), [
        [_vModelText, $setup.password]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", _hoisted_3, [
          (!$setup.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Login"))
            : _createCommentVNode("", true),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives(_createElementVNode("p", _hoisted_6, "Login failed", 512), [
        [_vShow, $setup.loginFailed]
      ])
    ], 32)
  ]))
}